import { render, staticRenderFns } from "./carDetailCarInout.vue?vue&type=template&id=4490ce7f"
import script from "./carDetailCarInout.vue?vue&type=script&lang=js"
export * from "./carDetailCarInout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports